<template>
  <div class="flex w-full h-full">
    <div class="items-center justify-center w-full h-full flex-wrap">
      <div class="w-full items-center justify-center mt-10">
        <img src="@/assets/images/hireful/newlogo.svg" loading="lazy" alt="hireful logo" class="hireful-logo-container" />
      </div>
      <div class="w-full items-center justify-center text-hireful hireful-font-semibold hireful-title mt-14">
        {{pageTitle}}
      </div>
      <div class="flex w-full items-center justify-center mt-5">
        <hr class="divider hireful-yellow">
      </div>
      <div class="flex flex-wrap w-full items-center justify-center">
        <div class="flex flex-wrap w-full items-center justify-center">
            <div class="flex flex-wrap w-full items-center justify-center">
              <select-account :accounts="accountsResponse" btnText="Switch" />
            </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  CognitoUserPool,
  CookieStorage
} from 'amazon-cognito-identity-js'
import axios from 'axios'
import store from '@/store'
import selectAccount from '@/components/selectAccount'
import { PublicClientApplication } from '@azure/msal-browser'

export default {
  name: 'switchAccount',
  components: {
    selectAccount
  },
  data () {
    return {
      accountsResponse: {},
      pageTitle: 'please select your account to log in',
      accessToken: null,
      parsedParams: {}
    }
  },
  created () {
    this.$route.path.substring(1).split('&')
      .map(part => part.replace(/^#/, ''))
      .forEach(param => {
        const parts = param.split('=')
        this.parsedParams[parts[0]] = parts[1]
      })
    if (this.parsedParams.access_token) {
      this.accessToken = this.parsedParams.access_token
    }
  },
  mounted () {
    const msalConfig = {
      auth: {
        clientId: process.env.VUE_APP_MICROSOFT_CLIENT_ID,
        authority: 'https://login.microsoftonline.com/common/'
      }
    }
    this.msalInstance = new PublicClientApplication(msalConfig)
    this.getAccounts()
  },
  methods: {
    async getAccounts () {
      try {
        const vm = this
        const poolData = {
          UserPoolId: process.env.VUE_APP_COGNITO_USER_POOL_ID,
          ClientId: process.env.VUE_APP_COGNITO_CLIENT_ID,
          Storage: new CookieStorage({ domain: `.${process.env.VUE_APP_HIREFUL_APP_DOMAIN}` })
        }
        const userPool = new CognitoUserPool(poolData)
        const cognitoUser = userPool.getCurrentUser()
        if (cognitoUser != null) {
          cognitoUser.getSession(async (err, session) => {
            if (err) {
              console.log(err.message || JSON.stringify(err))
              return false
            }
            vm.accessToken = session.accessToken.jwtToken
          })
        } else if (this.getCookie('loginOrigin') === 'microsoft') {
          const loginResponse = await this.msalInstance
            .ssoSilent({
              scopes: ['email']
            })
          vm.accessToken = loginResponse?.idToken
        } else if (this.getCookie('loginOrigin') === 'google') {
          vm.loginGoogleUser()
        }
        axios.defaults.headers.common.Authorization = `Bearer ${vm.accessToken}`
        const withCredentialsConfig = {
          method: 'GET'
        }
        const resp = await axios(`${process.env.VUE_APP_LOGIN_API_HOST}${store.state.routes.getClientsList}`, withCredentialsConfig)
        console.log(vm.accountsResponse)
        vm.accountsResponse = resp.data
        console.log(vm.accountsResponse)
      } catch (e) {
        console.log(e)
        this.$router.push({ name: 'Login' })
      }
    },
    loginGoogleUser () {
      const cognitoDomain = process.env.VUE_APP_COGNITO_DOMAIN
      const cognitoClientId = process.env.VUE_APP_COGNITO_CLIENT_ID
      const REDIRECT_URI = `https://login.${process.env.VUE_APP_HIREFUL_APP_DOMAIN}`
      const scope = 'aws.cognito.signin.user.admin%20email%20openid'
      const idp = 'Google'
      window.location.href = `${cognitoDomain}/oauth2/authorize?identity_provider=${idp}&response_type=TOKEN&client_id=${cognitoClientId}&redirect_uri=${REDIRECT_URI}&scope=${scope}&state=${idp}-switch-account`
    },
    getCookie (name) {
      const nameEQ = `${name}=`
      const ca = document.cookie.split(';')
      for (let i = 0; i < ca.length; i += 1) {
        let c = ca[i]
        while (c.charAt(0) === ' ') {
          c = c.substring(1, c.length)
        }
        if (c.indexOf(nameEQ) === 0) {
          return c.substring(nameEQ.length, c.length)
        }
      }
      return null
    }
  }
}
</script>

<style>

</style>
